import {store} from "../store/store";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {setProfileEmpty} from "../screens/Profile/redux/profile.action";
import {navigate, navigationReset} from "../navigation/rootNavigation";
import {setIsLogin} from "./commonredux/commonRedux.action";
import {headerSet} from "./networkFetch";
import CONFIG from "../config/config";
import {trackMoengageEvent} from "./commonMethods";
import {globalImport} from "../common/globalImports";

export const logout = async () => {
  var currentdate = Date.now();
  // First reset navigation state
  navigationReset();
  
  const isloggedIn = await AsyncStorage.getItem("token");
  if (isloggedIn) {
    await AsyncStorage.removeItem("logedIn");
    await AsyncStorage.removeItem("userMobNumber");
    await AsyncStorage.removeItem("token");

    if (globalImport.isWeb) {
      localStorage.removeItem("token");
      localStorage.removeItem("partner");
    } else {
      await AsyncStorage.removeItem("token");
    }

    await AsyncStorage.removeItem("CTProfileSet");
    await AsyncStorage.removeItem("userProfile");
    store.dispatch(setIsLogin(false));
    store.dispatch(setProfileEmpty());

    headerSet(CONFIG.LOG_OUT_TOKEN);
  }

  //navigate('Home', 'Home', 'Markets');
  // setTimeout(() => {
  //   navigate();
  //   // window.location.href = '/';
  // }, 100);
};
